<template>
    <svg :class="className" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.232333 0.232333C-0.0774444 0.542111 -0.0774444 1.04436
            0.232333 1.35414L3.8782 5L0.232333 8.64586C-0.0774444 8.95564 -0.0774444 9.45789 0.232333 9.76767C0.542111
            10.0774 1.04436 10.0774 1.35414 9.76767L5 6.1218L8.64586 9.76767C8.95564 10.0774 9.45789 10.0774 9.76767
            9.76767C10.0774 9.45789 10.0774 8.95564 9.76767 8.64586L6.1218 5L9.76767 1.35414C10.0774 1.04436 10.0774
            0.542111 9.76767 0.232333C9.45789 -0.0774444 8.95564 -0.0774444 8.64586 0.232333L5 3.8782L1.3541
            0.232333C1.04436 -0.0774444 0.542111 -0.0774444 0.232333 0.232333Z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>

